import React, { useId, useState } from "react";

export interface QA {
  question: string;
  answer: string;
}

interface AccordionProps {
  items: QA[];
}

/** Single-open accordion matching the design's grid-rows reveal. */
const Accordion: React.FC<AccordionProps> = ({ items }) => {
  const [open, setOpen] = useState<number | null>(null);
  const base = useId();

  return (
    <div className='accordion'>
      {items.map((item, i) => {
        const isOpen = open === i;
        const triggerId = `${base}-trigger-${i}`;
        const panelId = `${base}-panel-${i}`;
        return (
          <article className='accordion__item' data-open={isOpen} key={item.question}>
            <h3>
              <button
                aria-controls={panelId}
                aria-expanded={isOpen}
                id={triggerId}
                type='button'
                onClick={() => setOpen(isOpen ? null : i)}>
                <span>{item.question}</span>
                <span aria-hidden='true' className='accordion__icon'>
                  +
                </span>
              </button>
            </h3>
            <div
              aria-labelledby={triggerId}
              className='accordion__panel-grid'
              id={panelId}
              role='region'>
              <div className='accordion__panel-overflow'>
                <p>{item.answer}</p>
              </div>
            </div>
          </article>
        );
      })}
    </div>
  );
};

export default Accordion;
